export default "__VITE_ASSET__DsLI5WhY__"